import { render, staticRenderFns } from "./filtersList.vue?vue&type=template&id=0327d795&"
import script from "./filtersList.vue?vue&type=script&lang=ts&"
export * from "./filtersList.vue?vue&type=script&lang=ts&"
import style0 from "./filtersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports